import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";
import useDSPSellerInfo from "./useDSPSellerInfo";

export const useDSPLineItemTargetData = (lineItemEntityId: string | undefined) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const { dspAdvertiser } = useDSPSellerInfo();

  const { data, isLoading } = useQuery({
    queryKey: ["dspLineItemTargetData", lineItemEntityId, marketPlace],
    queryFn: async () => {
      const res = await apiClient.dspTargetList({
        queries: {
          line_item: String(lineItemEntityId),
          marketplace: marketPlace,
          limit: 5000,
        },
      });
      return res.results;
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!lineItemEntityId && !!dspAdvertiser?.id,
  });

  return { data, isLoading };
};
